import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Wubook**
 *
 * Official: https://wubook.net
 *
 * Example: <a href="http://www.feelhostels.com/reservas-picasso.html" target="_blank">Feel Apartments Picasso Center</a>
 *
 * @exports bs_42
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      if (window.location.hostname === 'wubook.net') {
        const aux = (document.querySelector('#current_flag  > span') || {}).textContent;

        if (aux && ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }
        reject('no_language');
      } else {
        resolve('es');
      }
    });
  };

  engine.priceObserveDom = function priceObserveDom(ctx) {
    const currencySelector = document.querySelector('ul.curswitcher li.current');

    if (currencySelector) {

      thn.currencyChangeRefresh = thn.debounce(() => thn.widgets.price.refresh(), 600);

      thn.observeDom(currencySelector, thn.currencyChangeRefresh, {
        childList: true,
        subtree: true,
        characterData: false,
      });

      thn.pageUnload(function () {
        thn.currencyChangeRefresh.cancel();
        thn.stopObserveDom(currencySelector, thn.currencyChangeRefresh);
        delete thn.currencyChangeRefresh;
      });

    }

  };

  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};

    // Dates
    const dateIn = ((document.querySelector('form#aform input[name=idfrom]') || {}).value || '');
    const dateOut = ((document.querySelector('form#aform input[name=idto]') || {}).value || '');

    if (dateIn && dateOut) {
      widgetData.dateBegin = translateDate(dateIn, thn.data.language || 'en');
      widgetData.dateEnd = translateDate(dateOut, thn.data.language || 'en');
    }
    // If we couldn't translate the date, let's try to replace it
    if (dateIn && dateOut && !widgetData.dateBegin && !widgetData.dateEnd) {
      widgetData.dateBegin = dateIn.replace(/(\d{2})\D+(\d{2})\D+(\d{4})/, '$3/$2/$1');
      widgetData.dateEnd = dateOut.replace(/(\d{2})\D+(\d{2})\D+(\d{4})/, '$3/$2/$1');
    }

    // Guests
    // Some hotels allow to choose the number of guests in the index page, others don't so we have to detect if the price is for one guest or for more.
    // In this cases we map the prices and we determine the number of guests for that price.

    const filterAdults = document.querySelectorAll('.date_group_generic')[2];
    const pricesList = [...document.querySelectorAll('.isroom ._x_price_value')].map((el) => thn.parseNumber(el.textContent));

    if (filterAdults) {
      widgetData.adults = thn.parseNumber(document.querySelector('select.adult_guests')?.value || '2');
    } else {
      const detailsList = [...document.querySelectorAll('.room__opt_left')];
      const adultsPriceList = detailsList.map((el) => ({
        adults: thn.parseNumber(el.querySelector('.occupancy_content span')?.getAttribute('data-tooltip')),
        price: thn.parseNumber(el.querySelector('.isroom ._x_price_value')?.textContent),
      }));
      const lowestPriceList = adultsPriceList.sort((a, b) => a.price - b.price);
      widgetData.adults = lowestPriceList[0]?.adults || 2;
    }
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    widgetData.rooms = thn.parseNumber((document.querySelector('form select#num_of_rooms') || {}).value || '1');

    // Prices
    const prices = pricesList.filter(Boolean);
    const currency = thn.parseCurrency((document.querySelector('div#checkout_recap .x_price_currency') || {}).textContent);

    if (!thn.empty(prices) && currency) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = currency;
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;

    }

    return widgetData;
  };

  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    const price = document.querySelector('table#prices_recap .x_price')?.textContent;
    const dateIn = document.querySelector('table#reservation span[itemprop=checkinDate]')?.textContent?.trim();
    const dateOut = document.querySelector('table#reservation span[itemprop=checkoutDate]')?.textContent?.trim();
    const bookingId = document.querySelector('table#reservation span[itemprop=reservationNumber]')?.textContent?.trim();

    widgetData.bookingId = bookingId;
    if (dateIn && dateOut) {
      widgetData.dateBegin = translateDate(dateIn, thn.data.language || 'en');
      widgetData.dateEnd = translateDate(dateOut, thn.data.language || 'en');
    }
    if (price) {
      widgetData.currency = thn.parseCurrency(price);
      widgetData.price = thn.parseNumber(price);
    }

    return widgetData;
  };

  return engine;

}

export { factory };
